import React, { Component } from "react";
import { connect } from "react-redux";
import { firestoreConnect, isLoaded } from "react-redux-firebase";
import { compose } from "redux";
import PressmarkSearch from "./components/pressmarks/PressmarkSearch";
import PressmarkList from "./components/pressmarks/PressmarkList";
import Notifications from "./components/notifications/Notifications";
import Layout from "./components/layout/Layout";
import Spinner from "./components/spinner/Spinner";

class App extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.state = {
      visiblePressmarks: [],
      searchError: ""
    };
  }

  onSubmit = searchValue => {
    let visiblePressmarks = this.props.pressmarks.filter(item => {
      return (
        item.pressmark
          .toLowerCase()
          .replace(/\s+/g, "")
          .indexOf(searchValue.toLowerCase().replace(/\s+/g, "")) > -1
      );
    });

    let searchError =
      visiblePressmarks.length === 0 ? "В каталоге нет такого шифра" : "";

    this.setState({
      visiblePressmarks,
      searchError
    });
  };

  render() {
    return (
      <Layout>
        {!isLoaded(this.props.pressmarks) ? (
          <Spinner />
        ) : (
          <div className="container">
            <div className="row">
              <div className="col-sm-7 order-sm-12">
                <Notifications notifications={this.props.notifications} />
              </div>
              <div className="col-sm-5 order-sm-1">
                <div className="row justify-content-center">
                  <div className="col-10 col-sm-12 col-md-10">
                    <PressmarkSearch onSubmit={this.onSubmit} />
                  </div>
                  <div className="col-10">
                    <PressmarkList pressmarks={this.state.visiblePressmarks} />
                    <p className="text-danger">{this.state.searchError}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </Layout>
    );
  }
}

const mapStateToProps = (state, props) => {
  return {
    pressmarks: state.firestore.ordered.pressmarks,
    notifications: state.firestore.ordered.notifications
  };
};

export default compose(
  connect(
    mapStateToProps,
    null
  ),
  firestoreConnect([
    { collection: "pressmarks" },
    { collection: "notifications", limit: 3, orderBy: ["time", "desc"] }
  ])
)(App);
